import React, { Component } from "react";
import PropTypes from "prop-types";
import { injectIntl, intlShape, FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import messages from "components/messagesDescription";
import ComposeMessageForm from "./ComposeMessageForm";
import { getRootMessages, postMessage, postMessageSuccess } from "actions/messagingActions";

class ComposeMessageContainer extends Component {
  onFormSubmitSuccess = (response, dispatch, props) => {
    this.props.postMessageSuccess(response, dispatch, props);
    this.props.getRootMessages();
  };

  render() {
    const { isComposeMessage, isNarrowScreen, onCancel } = this.props;

    if (!isComposeMessage) return null;

    return (
      <div>
        <h4>
          <FormattedMessage {...messages.inAppMessages.newMessage} />
        </h4>
        <ComposeMessageForm
          onPostMessageSuccess={this.onFormSubmitSuccess}
          isComposeMessage={isComposeMessage}
          isNarrowScreen={isNarrowScreen}
          onCancel={onCancel}
        />
      </div>
    );
  }
}

ComposeMessageContainer.propTypes = {
  intl: intlShape.isRequired,
  postMessage: PropTypes.func,
  getRootMessages: PropTypes.func,
  postMessageSuccess: PropTypes.func,
  onCancel: PropTypes.func,
};

const mapDispatchToProps = {
  getRootMessages,
  postMessage,
  postMessageSuccess,
};
export default injectIntl(
  connect(
    null,
    mapDispatchToProps
  )(ComposeMessageContainer)
);



// WEBPACK FOOTER //
// ./components/inAppMessages/ComposeMessageContainer.js